export enum RetriageFinishedStatus {
  ALREADY_MED = "ALREADY_MED",
  RECENTLY_RETRIAGED = "RECENTLY_RETRIAGED",
  EXTERNAL_GLP1_NO_ELIGIBLE_PROGRAMS = "EXTERNAL_GLP1_NO_ELIGIBLE_PROGRAMS",
  ALREADY_IN_BEST_PROGRAM = "ALREADY_IN_BEST_PROGRAM",
  EXCLUDED_FROM_HIGHER_ACUITY_PROGRAMS = "EXCLUDED_FROM_HIGHER_ACUITY_PROGRAMS",
}
